// extracted by mini-css-extract-plugin
export default {"deleteButton":"Input_deleteButton__xw6az","fieldSmallerMargin":"Input_fieldSmallerMargin__ijlN4","label":"Input_label__OwMKX"};